import type { PluginInvocationMessage } from '@atlassian/conversation-assistant-service-api/plugins';
import { ROVO_CHAT_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/rovo-chat-client';
import { JIRA_NL_TO_JQL_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/jira-nl-to-jql-client';
import { JiraNLToJQLCommand } from '@atlassian/rovo-content-bridge-api-commands/jira-nl-to-jql-command';
import { getBrowserBridgeAPI } from '@atlassian/rovo-content-bridge-api/singleton';

/*
	This file exists as part of the 'rovo_chat_jira_nl_to_jql_minion_in_fe' feature.
	It can be freely deleted if the feature is being removed.
*/

// input parameters defined in convo-ai repo here:
// https://bitbucket.org/atlassian/conversational-ai-platform/src/main/modules/product/rovo/rovo-api/src/main/kotlin/io/atlassian/micros/convoai/product/rovo/agent/tools/jira/issuesearch/IssueSearchToolDefinition.kt#lines-32,54
type IssueSearchToolInput = {
	jql: string;
	numIssues: number | undefined;
	fieldsToReturn: string | undefined;
	numComments: number | undefined;
	nextPageToken: string | undefined;
};

export const IssueSearchToolPluginInvocationsHandler = (
	pluginInvocation: PluginInvocationMessage,
): void => {
	// guard checks
	const pluginInput = pluginInvocation.plugin_input;
	if (!pluginInput) {
		return;
	}

	// extract jql from the plugin invocation
	let jql: string;
	try {
		const parsedInput: IssueSearchToolInput = JSON.parse(pluginInput);
		jql = parsedInput.jql;
	} catch {
		return;
	}

	if (!jql) {
		return;
	}

	const bridge = getBrowserBridgeAPI();
	bridge.send(JiraNLToJQLCommand, {
		receiverId: JIRA_NL_TO_JQL_CLIENT_ID,
		senderId: ROVO_CHAT_CLIENT_ID,
		data: [
			{
				jql: jql,
			},
		],
	});
};
